// import React from "react";

// const ServiceIntro = () => {
//   return (
//     <div className="flex flex-col items-center justify-center text-center py-12">
//       {/* Büyük Logo */}
//       <img
//         src="/images/logo.png"
//         alt="Logo"
//         className="w-[885px] h-auto mb-6"
//       />
//       <h2 className="text-black text-2xl font-bold">ANKARA'NIN PROFESYONEL TEMİZLİK ÇÖZÜMLERİ </h2>
//       {/* Açıklama Metni */}
//       <p className="text-gray-800 text-lg font-bold mx-11">
//         Ankara genelinde hizmet veren Abone Halı Yıkama ev ve iş yerlerinin
//         temizlik ihtiyaçlarına yönelik uzman çözümler sunar. Modern ekipman,
//         hijyenik uygulamalar ve müşteri memnuniyeti odaklı yaklaşımıyla,
//         temizlik artık sizin için zahmetsiz bir hizmete dönüşüyor.
//       </p>
//     </div>
//   );
// };

// export default ServiceIntro;
import React from "react";

const ServiceIntro = () => {
  return (
    <div className="flex flex-col items-center justify-center text-center py-12 px-4">
      {/* Logo */}
      <img
        src="/images/logo.png"
        alt="Abone Halı Yıkama Logo"
        className="max-w-[885px] w-full h-auto mb-6"
      />

      {/* Başlık */}
      <h2 className="text-black text-2xl md:text-3xl font-bold mb-4">
        ANKARA'NIN PROFESYONEL TEMİZLİK ÇÖZÜMLERİ
      </h2>

      {/* Açıklama Metni */}
      <p className="text-gray-800 text-base md:text-lg font-medium max-w-screen-lg">
        Ankara genelinde hizmet veren <span className="font-semibold">Abone Halı Yıkama</span>,
        ev ve iş yerlerinin temizlik ihtiyaçlarına yönelik uzman çözümler sunar.
        Modern ekipman, hijyenik uygulamalar ve müşteri memnuniyeti odaklı
        yaklaşımıyla, temizlik artık sizin için zahmetsiz bir hizmete dönüşüyor.
      </p>
    </div>
  );
};

export default ServiceIntro;
